export const extractValueOrTransform = (item, keyOrFn) =>
  typeof keyOrFn === 'function' ? keyOrFn(item) : item[keyOrFn]

export function isDexieTableExists(dx, name) {
  return dx.tables.map((d) => d.name).includes(name)
}

export function getSingleData(dx, tableName, uuid) {
  return dx.table(tableName).where({ externalId: uuid }).toArray()
}
